import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { ReleaseNotesComponent } from './features/general/release-notes/release-notes.component';
import { ProductionGuard } from './core/services/guards/production-guard.service';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { CustomRouteReuseStrategy } from './core/helpers/route-strategy';
import { SurveyLayoutComponent } from './layouts/survey-layout/survey-layout.component';
import { InvalidUrlComponent } from './features/invalid-url/invalid-url.component';
const ROUTES: Routes = [
    { path: 'release-notes', component: ReleaseNotesComponent, title: 'Release Note', canActivate: [ProductionGuard] },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./layouts/auth-layout/auth-layout.module').then((m) => m.AuthLayoutModule),
            },
        ],
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./layouts/admin-layout/admin-layout.module').then((m) => m.AdminLayoutModule),
            },
        ],
    },
    {
        path: '',
        component: SurveyLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./layouts/survey-layout/survey-layout.module').then((m) => m.SurveyLayoutModule),
            },
        ],
    },
    {
        path: '**',
        component: InvalidUrlComponent,
        data: { title: 'pageTitle.404PageNotFound' },
    },
];

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        RouterModule.forRoot(ROUTES, {
            anchorScrolling: 'disabled',
            scrollPositionRestoration: 'disabled',
            onSameUrlNavigation: 'reload',
        })
    ],
    exports: [RouterModule],
    providers: [{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }],
})
export class AppRoutingModule {}
